import { abyssColors } from '@/theme/colors';
import { Box, Button, Skeleton, Stack, Typography } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';

type ButtonProps = {
  contained?: boolean;
};

export const TimeLine = muiStyled(Box)(() => ({
  position: 'absolute',
  height: 'calc(100% - 20px)',
  width: '1px',
  left: '3px',
  zIndex: -1,
  top: '20px',
  background: abyssColors.primary[200],
}));

export const VersionContainer = muiStyled(Stack)(() => ({
  overflowY: 'auto',
  msOverflowStyle: 'none',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': { display: 'none' },
}));
export const CustomSkeleton = muiStyled(Skeleton)(() => ({
  borderRadius: '2px',
  height: '18px',
}));

export const ActionButton = muiStyled(Button)(({ contained }: ButtonProps) => ({
  padding: '0.6rem 1.6rem',
  height: '3.6rem',
  borderRadius: '0.4rem',
  fontSize: '1.4rem',
  background: contained ? abyssColors.primary[500] : abyssColors.neutral[50],
  color: contained ? abyssColors.neutral[50] : abyssColors.primary[500],
  boxShadow: 'none',
  textTransform: 'none',
  width: 'fit-content',
  lineHeight: 'normal',
  marginLeft: '0px !important',
  gap: '0.6rem',
  '&:disabled': {
    background: contained ? abyssColors.neutral[300] : abyssColors.neutral[50],
    color: contained ? abyssColors.neutral[50] : abyssColors.primary[300],
  },
  '&:hover': {
    background: contained ? abyssColors.primary[400] : abyssColors.neutral[50],
  },
}));

export const DialogHeading = muiStyled(Typography)(() => ({
  fontSize: '2rem',
  lineHeight: 'normal',
  fontWeight: 500,
  color: abyssColors.primary[700],
}));

export const DialogText = muiStyled(Typography)(() => ({
  fontSize: '1.4rem',
  lineHeight: '2rem',
  color: abyssColors.primary[700],
}));
